/**
 * Utility functions for handling safe area insets on mobile devices
 * (notches, system bars, etc.)
 */

/**
 * Returns CSS padding values that respect safe area insets
 * @param basePadding - Base padding value (default: 1.25rem = 20px)
 * @returns Object with paddingTop, paddingBottom, paddingLeft, paddingRight
 */
export function getSafeAreaPadding(basePadding: string = '1.25rem'): {
  paddingTop: string
  paddingBottom: string
  paddingLeft: string
  paddingRight: string
} {
  return {
    paddingTop: `calc(${basePadding} + env(safe-area-inset-top, 0px))`,
    paddingBottom: `calc(${basePadding} + env(safe-area-inset-bottom, 0px))`,
    paddingLeft: `calc(${basePadding} + env(safe-area-inset-left, 0px))`,
    paddingRight: `calc(${basePadding} + env(safe-area-inset-right, 0px))`,
  }
}

/**
 * Returns a complete style object for a page container with safe area padding
 * @param backgroundColor - Background color for the page
 * @param textColor - Text color for the page
 * @param basePadding - Base padding value (default: 1.25rem)
 * @returns Complete style object for page containers
 */
export function getPageContainerStyles(
  backgroundColor: string,
  textColor: string,
  basePadding: string = '1.25rem'
): React.CSSProperties {
  return {
    backgroundColor,
    color: textColor,
    ...getSafeAreaPadding(basePadding),
  }
}
